module.exports = __webpack_public_path__ + "9b09aab5e3fc54353ca8a7fc1411352f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-3.jpg
// module id = 392
// module chunks = 0